import React from 'react';
import TariffsStyles from '../m_styles.less';

export const CardBadge: React.FC<{ name: string }> = ({ name }: { name: string }) => {
    return <span className={TariffsStyles.cardBadge}>{name}</span>;
};
